<div class="w-full h-full flex flex-col justify-center items-center">
	<h1 class="text-2xl">No track activity at this time.</h1>
	@if (seriesName === 'IMSA') {
		<img class="max-h-20 mt-10" [src]="'/assets/imsa.png'" />
	} @else if (seriesName === 'SRO') {
		<img class="max-h-20 mt-10" [src]="'/assets/sro-motorsports-group.svg'" />
	}
</div>
